import React from 'react';

import { Box, Button, Flex, getTheme, thc } from '@flightstats/airframe-react';
import styles from './poweredByCirium.module.css';

export const isWindowSmallerThan = (size: string): boolean => {
  const breakpoint = getTheme(false).breakpoints[size];
  return (
    (window.innerWidth || (document.body && document.body.clientWidth)) <
    parseInt(breakpoint.substring(0, breakpoint.length - 2), 10)
  );
};

export const ArrangeInputs = thc(Flex, {
  justifyContent: 'space-between',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
});

export const InputWrapper = thc(Box, {
  width: {
    xs: '100%',
    md: 'calc(50% - 16px)',
  },
});

interface FormControlsProps {
  disabled: boolean;
  label: string;
}

export const FormControls: React.FC<FormControlsProps> = ({ disabled, label }) => {
  return (
    <Flex className={styles.formControls}>
      <Button disabled={disabled} type="submit">
        {label}
      </Button>
    </Flex>
  );
};